<template>
    
    <div class="mainManu">
       
        <div v-for="(item, key) in $store.state.templates.data" :key="key">
            <router-link   v-bind:to="{ name: 'Template', params: { id: item.id } }" class="navbar-brand">
               {{ item.name.toUpperCase() }}
            </router-link>
        </div>

        <div>
            <router-link to="/send-message/custom" class="navbar-brand">
                CUSTOM
            </router-link>
        </div>
        
    </div>
</template>

<script>
//import {mapActions, mapState} from 'vuex'
export default {
    props:[],
    methods: {

    },
    computed:{
       
    },
    created(){
        
    }
}
</script>

<style>

</style>